
import { useGammaWebServices, useLocation, useOrgSettings } from "@/services";
import { AnyLocation, RiskOverride } from "@/types";
import { defineComponent } from "vue";

export default defineComponent({
  computed: {
    options() {
      const overrides =
        useOrgSettings().selectedBusinessLine?.riskLookupOverrides?.options[0]
          ?.overrides || [];
      return [
        ...overrides.map((x) => ({
          value: x,
          text: x.riskLookupName,
        })),
      ];
    },
    selectionDescription(): string | undefined {
      return useOrgSettings().selectedBusinessLine?.riskLookupOverrides
        ?.selectionDescription;
    },
    selectedOption: {
      get() {
        return useOrgSettings().selectedRiskOverride;
      },
      set(val: RiskOverride | null) {
        useOrgSettings().selectedRiskOverride = val;
      },
    },
  },

  watch: {
    selectedOption: {
      async handler() {
        const location = useLocation().location as AnyLocation;

        if (location) {
          const result = await useGammaWebServices().fetchRiskLookups(
            location,
            useOrgSettings().riskLookups
          );
          await useGammaWebServices().logLocation(location);

          if (!Object.keys(result).length) {
            this.$bvToast.toast("One or more risk info failed to load", {
              title: "Loading of Risks failed.",
              variant: "danger",
              solid: true,
            });
          }
        }
      },
      immediate: false,
    },
  },
  methods: {
    makeToast(title: string, variant: string, message: string) {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      });
    },
  },
});
